// Types
import { MimeType } from './mimeConstants';

const ALL_MIME_TYPES = new Set(Object.values(MimeType));
const IMAGE_MIME_TYPES = new Set([MimeType.GIF, MimeType.WEBP, MimeType.JPEG, MimeType.SVG, MimeType.PNG]);

const createMimeType = (mimeString: string): MimeType | null =>
    ALL_MIME_TYPES.has(mimeString as MimeType) ? (mimeString as MimeType) : null;

/**
 * Whether the provided mime type string represents an image mime type.
 */
export const isImageMimeType = (mimeString: string): Boolean => {
    const mimeType = createMimeType(mimeString);

    if (!mimeType) return false;

    return IMAGE_MIME_TYPES.has(mimeType);
};
